module.exports = __webpack_public_path__ + "static/img/bg.3a6aff3b.png";